/**
 * Gestisce la scheda delle entità collegate agli eventi: artisti, curatori, ecc...
 */
import Pagination from "./pagination";
import Spinner from "./spinner";
import {wp_trim_words} from "./wp";

class EventsEntity {
    /**
     * @param {string} selector
     */
    constructor(selector) {
        document.querySelectorAll(selector).forEach(container => {
            this.init(container);
        });
    }

    /**
     * @param {HTMLElement} container
     */
    init(container) {
        container.querySelector("[role=tablist].js-tabs")?.addEventListener("activate", event => {
            let panel = event.detail.panel;

            if ("true" === panel.dataset.eventsLoaded) {
                return;
            }

            let url = new URL(panel.dataset.eventsUrl);
            url.searchParams.set("pag", "1");

            this.#fetchEvents(url, panel);
        });

        container.addEventListener("click", event => {
            if (event.target.matches(".c-pagination button")) {
                event.preventDefault();

                let url = new URL(event.target.dataset.url);
                let panel = event.target.closest("[role=tabpanel]");

                this.#fetchEvents(url, panel);
            }
        });
    }

    /**
     * @param {URL} url
     * @param {HTMLElement} panel
     */
    #fetchEvents(url, panel) {
        let container = panel.querySelector(".js-events-entity-panel");
        let spinner = new Spinner(panel.querySelector(".js-events-entity-loading"));

        // inizio loading
        spinner.start();
        container.innerHTML = "";

        fetch(url.toString())
            .then(response => response.json())
            .then(data => {
                if (data.events.length === 0) {
                    container.innerHTML = '<div class="u-cq u-row"><div class="c-alert -warning">Non ci sono eventi in questa sezione</div></div>';
                } else {
                    let events = '<div class="u-cq u-row">' + this.#getEventsHtml(data.events) + '</div>';
                    let pagination = this.#getPaginationHtml(url, 12, data.meta.total_events);

                    container.innerHTML = events + pagination;
                }

                // fine loading
                spinner.end();
            });

        // mi assicuro che non esegua la chiamata ajax se la tab viene riattivata
        panel.dataset.eventsLoaded = "true";
    }

    /**
     * @param {Object[]} events
     * @returns {string}
     */
    #getEventsHtml(events) {
        let code = "";
        events.forEach(event => {
            code += this.#getEventHtml(event);
        });

        return code;
    }

    /**
     * @param {Object} event
     * @returns {string}
     */
    #getEventHtml(event) {
        let place = "";
        let city = "";
        let excerpt = "";

        if (event.place) {
            place = `<ul class="c-card_cat c-list -meta"><li><a href="${event.place.url}">${event.place.title}</a></li></ul>`;

            if (event.place.city) {
                city = `
<li>
    <svg role="img" focusable="false"><use xlink:href="${m6e.spriteUrl}#icon--place"></use></svg>
    <a href="${event.place.city.url}">${event.place.city.title}</a>
</li>
`;
            }
        }

        if (event.excerpt) {
            excerpt = `<p class="c-card_text">${wp_trim_words(event.excerpt, 20)}</p>`;
        }

        return `
<div class="c-card :event :standard -small">
    <figure class="c-card_media">
        <a href="${event.url}">
            ${event.image}
        </a>
    </figure>

    <div class="c-card_body u-cq">
        <div class="c-card_head">
            ${place}
            <h3 class="c-card_title"><a href="${event.url}">${event.title}</a></h3>
        </div>

        ${excerpt}

        <div class="c-card_foot">
            <ul class="c-list">
                ${city}
                <li>
                    <svg role="img" focusable="false">
                        <use xlink:href="${m6e.spriteUrl}#icon--calendar"></use>
                    </svg>
                    ${event.dates}
                </li>
            </ul>
        </div>
    </div>
</div>`;
    }

    /**
     * Restituisce il codice HTML per la paginazione degli eventi.
     *
     * @param {URL} url
     * @param {int} items_per_page
     * @param {int} total_events
     * @returns {string}
     */
    #getPaginationHtml(url, items_per_page, total_events) {
        let page = parseInt(url.searchParams.get("pag") || 1);

        let url_for_pagination = new URL(url.toString());
        url_for_pagination.searchParams.delete("pag");

        let pagination = (new Pagination()).render(
            url_for_pagination,
            total_events,
            items_per_page,
            page,
            {
                screen_reader_text: "Navigazione eventi",
                aria_label: "Paginazione eventi",
                type: "button"
            }
        );

        return `<div class="t-archive_pagination">${pagination}</div>`;
    }
}

export default EventsEntity;
